export const colors = {
    primary: '#e1dfe0',
    dark: '#484557'
}
export const spacings = {
    pageMargin: '30px',
    sectionMargin: '25px',
    subsectionMargin: '10px'
}